// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__RSNe8","info":"styles_info__EzN8B","poiTitle":"styles_poiTitle__uC_qt"};
module.exports.__checksum = "27259d6bdd19"
